import { supabase } from './supabase'

const TTL_MS = 60000
const _cache = new Map()

export async function startPrefetch(staffId) {
  if (!staffId) return
  const entry = {
    stores: [], machines: [], booths: [], booth_alerts: [], staff_stores: [],
    fetched_at: Date.now(),
    ready: false,
  }
  _cache.set(staffId, entry)
  try {
    const [storesRes, machinesRes, boothsRes, alertsRes, staffStoresRes] = await Promise.all([
      // eslint-disable-next-line supabase-guard/require-order -- LEGACY(D-330): 是正保留
      supabase.from('stores').select('store_code,store_name'),
      // eslint-disable-next-line supabase-guard/require-order -- LEGACY(D-330): 是正保留
      supabase.from('machines').select('machine_code,machine_name'),
      // eslint-disable-next-line supabase-guard/require-order -- LEGACY(D-330): 是正保留
      supabase.from('booths').select('booth_code,booth_number'),
      supabase.from('booth_alerts')
        .select('*, alert_types(label, icon_emoji, icon_key, color_hex)')
        .eq('resolved', false)
        .order('created_at', { ascending: false })
        .limit(50),
      // eslint-disable-next-line supabase-guard/require-order -- LEGACY(D-330): 是正保留
      supabase.from('staff_stores').select('store_code').eq('staff_id', staffId),
    ])
    entry.stores = storesRes.data || []
    entry.machines = machinesRes.data || []
    entry.booths = boothsRes.data || []
    entry.booth_alerts = alertsRes.data || []
    entry.staff_stores = staffStoresRes.data || []
    // D-299 IMPL_2(保険): RLS で読めない場合 supabase-js は throw せず error なしの空配列を返すため catch が発動しない。
    //   stores/machines/booths/staff_stores のいずれかが空なら「取得失敗」とみなし ready=false(=Launcher が正常経路で取り直す)。
    //   booth_alerts と alert_types は本当に 0 件があり得るので除外する。
    //   (IMPL_1 が正しく入れば発動しない。将来 anon prefetch が別経路で復活したときの保険。)
    const essentialEmpty = !entry.stores.length || !entry.machines.length || !entry.booths.length || !entry.staff_stores.length
    entry.ready = !essentialEmpty
  } catch {
    // ready stays false; Launcher falls back to normal fetch
  }
}

export function getCache(staffId) {
  if (!staffId) return null
  const entry = _cache.get(staffId)
  if (!entry) return null
  if (Date.now() - entry.fetched_at > TTL_MS) {
    _cache.delete(staffId)
    return null
  }
  return entry
}

export function clearCache() {
  _cache.clear()
}
